export default __webpack_public_path__ + "9c6b3a9a2bcc15d0f1c45c4a38c754a3.png";